<div class="header {{ headerTheme() }}">
  <div class="left-side">
    <div class="logo">
      <a routerLink="/dashboard">
        <img src="assets/images/logos/jfw_logo{{ headerLogo() }}.png" />
      </a>
    </div>
    <hr />
    <div class="title-and-nav">
      <div class="jfw-title-and-impersonation">
        <span class="jfw-title">
          @if (newSite()) {
            Dealer Portal
          } @else {
            Referral Dashboard
          }
        </span>
      </div>

      @if (firebaseUser() && firebaseUser()?.emailVerified) {
        <nav>
          <div class="header-link">
            <a routerLink="/dashboard">
              <span>Dashboard</span>
            </a>
          </div>
          @if (newSite()) {
            @for (
              moduleGroup of moduleGroups();
              track moduleGroup.displayName
            ) {
              <!-- ignore group that has no display name - these are the modules that are not listed in the header -->
              @if (moduleGroup.displayName) {
                <!-- A single-module group renders as a plain link rather than a
                one-item dropdown: either because the group IS that module (an
                ungrouped module, where the two display names are the same), or
                because the group is explicitly collapsible and the account's
                access left only one module in it (EXT-5379 -- an ecomStatus 'O'
                dealer's Support group). Either way the label is the group's own
                name. -->
                @if (
                  moduleGroup.modules.length === 1 &&
                  (moduleGroup.displayName ===
                    moduleGroup.modules[0].displayName ||
                    moduleGroup.collapseWhenSingle)
                ) {
                  <div class="header-link">
                    <a
                      [routerLink]="moduleGroup.modules[0].routes[0]"
                      routerLinkActive="active"
                    >
                      <span>{{ moduleGroup.displayName }}</span>
                    </a>
                  </div>
                } @else {
                  <div
                    class="header-link menu"
                    [matMenuTriggerFor]="subMenu"
                    #subMenuTrigger="matMenuTrigger"
                  >
                    <a>
                      <span>{{ moduleGroup.displayName }}</span>
                    </a>
                    @if (subMenuTrigger.menuOpen) {
                      <mat-icon>keyboard_arrow_up</mat-icon>
                    } @else {
                      <mat-icon>keyboard_arrow_down</mat-icon>
                    }
                  </div>
                  <!-- `class`, not `panelClass`: Angular Material aliases MatMenu's
                  panel-class input to `class` (@Input('class')), and a
                  `panelClass=` attribute is silently ignored -- the overlay
                  renders unstyled with no error anywhere. -->
                  <mat-menu #subMenu="matMenu" class="dp-header-menu">
                    @for (module of moduleGroup.modules; track module.module) {
                      <button mat-menu-item [routerLink]="module.routes[0]">
                        {{ module.displayName }}
                      </button>
                    }
                  </mat-menu>
                }
              }
            }
          } @else {
            @if (currentDealer()?.role === "Owner") {
              <div
                class="header-link menu"
                [matMenuTriggerFor]="reportsMenu"
                #reportsMenuTrigger="matMenuTrigger"
              >
                <a>
                  <span>Reports</span>
                </a>
                @if (reportsMenuTrigger.menuOpen) {
                  <mat-icon>keyboard_arrow_up</mat-icon>
                } @else {
                  <mat-icon>keyboard_arrow_down</mat-icon>
                }
              </div>
            }

            <mat-menu #reportsMenu="matMenu">
              <button
                [disabled]="!enableDealerReports"
                mat-menu-item
                routerLink="/reports/commission-statements"
              >
                Statements
              </button>
            </mat-menu>

            <div class="header-link">
              <a routerLink="/support" routerLinkActive="active">
                <span>Support</span>
              </a>
            </div>
          }
        </nav>
      }
    </div>
  </div>

  <div class="right-side">
    @if (firebaseUser() && firebaseUser()?.emailVerified) {
      @if (enableFeedback()) {
        <button
          mat-icon-button
          type="button"
          class="feedback-button"
          aria-label="Send feedback"
          title="Send feedback"
          (click)="openFeedback.emit()"
        >
          <mat-icon>campaign</mat-icon>
        </button>
      }
      <button
        mat-icon-button
        routerLink="/setup/account-info"
        aria-label="Account settings"
        title="Account settings"
      >
        <mat-icon>account_circle</mat-icon>
      </button>

      @if (displayName(); as displayName) {
        <div class="display-name">
          <span class="dealer-user-name">{{ displayName }}</span
          ><br />

          @if (currentDealer(); as currentDealer) {
            @if (userDealers(); as userDealers) {
              @if (userDealers.length > 1) {
                @if (dealerIdForm(); as dealerIdForm) {
                  <form [formGroup]="dealerIdForm">
                    <mat-select
                      [formControl]="dealerIdForm.controls.dealerId"
                      (selectionChange)="newDefaultDealerId.emit($event.value)"
                    >
                      @for (dealer of userDealers; track dealer.dealerId) {
                        <mat-option [value]="dealer.dealerId">
                          {{ dealer.dealerId }}
                        </mat-option>
                      }
                    </mat-select>
                  </form>
                }
              } @else {
                <span class="dealer-id">{{ currentDealer.dealerId }}</span>
              }
            }
          }
        </div>
      }
    }
  </div>
  @switch (servedEnvironment()) {
    @case ("local") {
      <div class="local-site">Local</div>
    }
    @case ("dev") {
      <div class="dev-site">Dev</div>
    }
    @case ("test") {
      <div class="test-site">Test</div>
    }
  }
</div>
